import styled from "@emotion/styled";
import {colors, sizes} from "patient-ping-remedy/packages/theme";

export const IconWrapper = styled.span<{margin: string}>`
  display: flex;
  margin: ${({margin}) => margin};
  width: ${sizes.medium};
  height: ${sizes.medium};
  justify-content: center;
    
  &:hover {
    background-color: ${colors.purple1};
    border-radius: 50%;  
  }
`;

export const TitleWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
`;
